export default __webpack_public_path__ + "static/media/GetGrowCart_Logo_Dark.e3fcc1e2.jpg";